module.exports = __webpack_public_path__ + "images/home/bg@2x-f36e9f22acb490609ee4db44b54f0e14.jpg";